/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:dbbd4eb2-e71b-4da9-b20f-86eed9f7088f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_SctOh0Kq0",
    "aws_user_pools_web_client_id": "76iqqbdr5h4m93st3i8dvicamp",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "mybookstoreb8bee94f4de64220bb462d66ee8e4071175912-dev",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://hyohcsq2gjgrlkfjqlwl45ovpe.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-o5zfmfgikbfmpjuxvnf342xgpu",
    "aws_content_delivery_bucket": "mybookstore-20230408214730-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://mybookstore-20230408214730-hostingbucket-dev.s3-website-us-east-1.amazonaws.com"
};


export default awsmobile;
